import { useEffect, useState } from "react";
import './styles.js';
import { Content } from "./styles.js";
import Load from "../../../../../components/load/index.js";
import Movie from "../../../../../components/movie/person/moov/index.js";

export default function MoviesMoov({ all_movies, movies_person, person_id, maximized, movieType }) {
    
    const [filteredMovies, setFilteredMovies] = useState([]);
    const [loadingMovies, setLoadingMovies] = useState(true);

    useEffect(() => {

        setLoadingMovies(true);

        if (all_movies?.movies && movies_person?.movies) {
            // Filtra os filmes de all_movies com base nos IDs encontrados em movies_person
            const personMovieIds = movies_person.movies
                .filter(movie =>
                    movie?.cast?.some(person => person.person_id === Number(person_id))
                )
                .map(movie => movie?.id_imdb);

            const moviesWithPerson = all_movies.movies.filter(movie =>
                personMovieIds.includes(movie?.id_imdb)
            );

            // Aplica o filtro baseado no movieType
            const moviesFilteredByType = moviesWithPerson.filter(movie => {
                if (movieType === "movie") {
                    return movie?.media_type === "movie";
                } else if (movieType === "tv") {
                    return movie?.media_type === "tv";
                }
                return true; // "all" exibe todos
            });

            setFilteredMovies(moviesFilteredByType);
            setLoadingMovies(false);
        }
    }, [all_movies, movies_person, person_id, movieType]);

    return (
        <>
            {loadingMovies ? (
                <Load align_center={true} />
            ) : (
                <Content maximized={maximized}>
                    {filteredMovies.map((movie, index) => (
                        <Movie
                            key={movie?.id_imdb || index}
                            person_id={person_id}
                            movie={movie}
                            movie_person={movies_person.movies.find(
                                (mp) => mp.id_imdb === movie.id_imdb
                            )}
                            character={movie?.character}
                            roles={movie?.character}
                        />
                    ))}
                </Content>
            )}
            {(filteredMovies.length === 0 && !loadingMovies) && (
                <span style={{textAlign: "center", marginTop: "20px"}}>Nenhum resultado encontrado.</span>
            )}
        </>
    );
}
